import React, { useEffect, useState } from "react";
import { Alert, Button, Empty, Spin } from "antd";
import { EnvironmentFilled } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";
import { getCustomerBranches } from "../../../services/customer";
import { asset, formatMetric, numberOrNull, safeImageUrl } from "../memberData";

export default function CustomerBranches({ member, onClose }) {
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(false);
  const [attempt, setAttempt] = useState(0);
  const [state, setState] = useState({ loading: true, branches: [], error: "" });
  useEffect(() => {
    const controller = new AbortController();
    setState({ loading: true, branches: [], error: "" });
    getCustomerBranches(controller.signal).then((response) => {
      if (controller.signal.aborted) return;
      if (response?.code !== 2000 || !Array.isArray(response.data)) throw new Error("invalid response");
      setState({ loading: false, branches: response.data, error: "" });
    }).catch(() => {
      if (!controller.signal.aborted) setState({ loading: false, branches: [], error: "Chưa tải được thông tin cơ sở. Vui lòng thử lại." });
    });
    return () => controller.abort();
  }, [attempt]);
  const cards = member.branches.length ? member.branches : state.branches.map((branch) => ({ branch_id: branch._id, branch_name: branch.name }));
  const book = (branch) => {
    onClose();
    navigate(`/order?branch=${encodeURIComponent(branch._id)}`);
  };
  return <section aria-label="Cơ sở" className="member-branches">
    <div className="member-branch-heading"><h3><img src={asset("branches-home.svg")} alt="" />{member.branches.length ? "Cơ sở hay đến" : "Khám phá cơ sở Muzic Box"}</h3>
      {cards.length > 2 && <button className="member-branch-more" aria-expanded={expanded} onClick={() => setExpanded(!expanded)}>{expanded ? "Thu gọn" : "Xem thêm"}<img src={asset("branches-next.svg")} alt="" /></button>}</div>
    {state.error && <Alert type="error" message={state.error} action={<Button size="small" onClick={() => setAttempt((value) => value + 1)}>Thử lại</Button>} />}
    <Spin spinning={state.loading}>
      {cards.length ? <div className={`member-branch-grid${expanded ? " member-branch-grid-expanded" : ""}`} tabIndex={0} role="region" aria-label="Danh sách cơ sở">
        {cards.map((item) => {
          const branch = state.branches.find((entry) => String(entry._id) === String(item.branch_id));
          const image = safeImageUrl(branch?.image || branch?.image_url);
          const mapUrl = /^https?:\/\//i.test(branch?.google_map_direct_link || "") ? branch.google_map_direct_link : "";
          return <article className="member-branch-card" key={item.branch_id}>
            <div className="member-branch-title"><h4>{branch?.name || item.branch_name || "Cơ sở Muzic Box"}</h4>{mapUrl ? <a href={mapUrl} target="_blank" rel="noopener noreferrer" aria-label={`Chỉ đường đến ${branch.name}`}><img src={asset("branches-location.svg")} alt="" /></a> : <img src={asset("branches-location.svg")} alt="" />}</div>
            <div className="member-branch-meta"><p className="member-muted" title={branch?.address}>{branch?.address || ""}</p>
            {numberOrNull(item.visit_count) !== null && <span className="member-branch-visits">{formatMetric(numberOrNull(item.visit_count))} {member.visitsSource === "order_new" ? "lượt ghé" : "lượt đặt phòng"}</span>}</div>
            <div className="member-branch-image">{image ? <img src={image} alt={branch?.name || "Cơ sở"} /> : <div className="member-branch-placeholder"><EnvironmentFilled /><span>Ảnh cơ sở đang cập nhật</span></div>}
            <Button className="member-book-button" onClick={() => book(branch)} disabled={!branch || state.loading}>Đặt phòng</Button></div>
          </article>;
        })}
      </div> : <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={state.loading ? "Đang tải cơ sở…" : "Chưa có thông tin cơ sở"} />}
    </Spin>
    <div className="member-branch-heading member-branch-promotion-heading"><h3><img src={asset("branches-promotion.svg")} alt="" /><span>Cơ sở đang có<br />Chương trình khuyến mại</span></h3></div>
    <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description="Chưa có thông tin khuyến mại" />
  </section>;
}
